import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import styled from "@emotion/styled";
import { IconButton, Tooltip } from "@avenue-8/sidekick-ui";
import { ReactNode } from "react";
import { DraggableAttributes } from "@dnd-kit/core";
import { useSortable } from "@dnd-kit/sortable";

type DragListeners = ReturnType<typeof useSortable>["listeners"];

export interface PresentationSectionSidebarAction {
  icon: ReactNode;
  tooltip: string;
  onClick: () => void;
}

interface Props {
  dragHandleRef: React.Ref<HTMLButtonElement>;
  dragHandleAttributes: DraggableAttributes;
  dragHandleListeners: DragListeners;
  actions?: PresentationSectionSidebarAction[];
}

const Sidebar = styled.div`
  position: absolute;
  top: 0;
  left: 0.25rem;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease-in-out;
  z-index: 10;
  padding-top: 0.75rem;
`;

const SidebarButton = styled(IconButton)`
  background-color: ${(p) => p.theme.button.outlined.colors.background};
` as typeof IconButton;

const DragHandleButton = styled(SidebarButton)`
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
` as typeof IconButton;

export const PresentationSectionSidebar = ({
  dragHandleRef,
  dragHandleAttributes,
  dragHandleListeners,
  actions = [],
}: Props) => {
  return (
    <Sidebar className="quick-sidebar">
      <Tooltip title="Drag to reorder" placement="right">
        <DragHandleButton
          ref={dragHandleRef}
          size="small"
          {...dragHandleAttributes}
          {...dragHandleListeners}
        >
          <DragIndicatorIcon fontSize="small" />
        </DragHandleButton>
      </Tooltip>
      {actions.map((action, i) => (
        <Tooltip key={i} title={action.tooltip} placement="right">
          <SidebarButton size="small" onClick={action.onClick}>
            {action.icon}
          </SidebarButton>
        </Tooltip>
      ))}
    </Sidebar>
  );
};
